export default __webpack_public_path__ + "static/media/CloudDeveloper.e76575bf.jpg";